module.exports = __webpack_public_path__ + "img/best-price.5b2ccc64.svg";